// Import the mixins
import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'

// Import firebase
import { firebaseAuth, usersModel } from '@/firebase/firebase-config'

export const HasNewSiteVersion = {

    /*
	**  Register the mixins
	*/

	mixins: [

        BugsnagService

    ],

    /*
    **  Set up the data
    */

    data: () => ({

        latest_version_updated: false

    }),

    /*
	**  Methods
    */
    
    methods: {

        hasNewSiteVersionHandler: function() {

            try {

                usersModel.doc(firebaseAuth.currentUser.uid).update({
                    'attributes.has_latest_version': true,
                    'meta.updated_at': moment().unix()
                })
                .then(() => {

                    /*  
                    **  Set the prop
                    **  @prop: @here
                    */

                    this.latest_version_updated = true;

                })
                .catch(error => {

                    /*  
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */
                
                    this.reportAuthBugsnagError({
                        title: 'Update the Has Latest App Version in Firestore',
                        errorType: 'Firestore Database',
                        section: 'Events/App',
                        uid: 'fSvRRKCz5mUttmfBSfE5',
                        error: error
                    });

                });

            } catch (e) {

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */
            
                this.reportAuthBugsnagError({
                    title: 'Unable to Update the User App Version in Firestore',
                    errorType: 'Firestore Database',
                    section: 'Events/App',
                    uid: 'kpNAmoroaW0xZeGfLw3j',
                    error: e
                });

            }

        }

    }

}